import { z } from 'zod'

export const permissionSchema = z.object({
    created_at: z.coerce.date(),
    name: z.string(),
    title: z.string(),
    updated_at: z.coerce.date(),
    uuid: z.string().uuid(),
})

export const permissionsSchema = z.array(permissionSchema)

export type Permission = z.infer<typeof permissionSchema>
export type Permissions = z.infer<typeof permissionsSchema>
